import React from "react";
import "./loading.css";

const Loading = ({isAuth = false}) => {
  return (
    <div className="loading" id="overlay_spinner">
      {isAuth ? (
        <div className="w-80 h-100 float-end position-relative">
          <div role="status" className="spinner-border spinner-border-xl"></div>
        </div>
      ) : (
        <div role="status" className="spinner-border spinner-border-xl"></div>
      )}
    </div>
  );
};

export default Loading;
